import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { Line } from 'react-chartjs-2';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';

const SessionsTab = ({ timeRange, customDateRange, chartOptions }) => {
    const [loading, setLoading] = useState(true);
    const [sessionsData, setSessionsData] = useState(null);

    useEffect(() => {
        loadSessionsData();
    }, [timeRange, customDateRange]);

    const loadSessionsData = async () => {
        setLoading(true);
        try {
            // Preparazione parametri per l'API
            const apiParams = { timeRange };
            if (timeRange === 'custom' && customDateRange.start && customDateRange.end) {
                apiParams.startDate = customDateRange.start;
                apiParams.endDate = customDateRange.end;
            }

            const response = await ApiManager.sendAuthenticatedRequest('/analytics/sessions', apiParams);
            setSessionsData(response?.data || response);
        } catch (error) {
            console.error('Error loading sessions data:', error);
            toast.error('Errore nel caricamento dati sessioni');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center py-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Caricamento...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <Row className="g-3">
            <Col lg={12}>
                <Card>
                    <Card.Header>
                        <Card.Title>Login / Logout</Card.Title>
                    </Card.Header>
                    <Card.Body style={{ height: '500px' }}>
                        {sessionsData?.logins && sessionsData?.logouts && sessionsData.labels ? (
                            <Line 
                                data={{
                                    labels: sessionsData.labels,
                                    datasets: [
                                        {
                                            label: 'Login',
                                            data: sessionsData.logins,
                                            borderColor: '#17a2b8',
                                            backgroundColor: 'rgba(23, 162, 184, 0.1)',
                                            fill: true,
                                            tension: 0.4
                                        },
                                        {
                                            label: 'Logout',
                                            data: sessionsData.logouts,
                                            borderColor: '#6c757d',
                                            backgroundColor: 'rgba(108, 117, 125, 0.1)',
                                            fill: true,
                                            tension: 0.4
                                        }
                                    ]
                                }}
                                options={chartOptions}
                            />
                        ) : (
                            <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                                <div className="text-center">
                                    <FontAwesomeIcon icon={faChartLine} size="3x" className="mb-3" />
                                    <p>Dati login/logout non disponibili</p>
                                </div>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default SessionsTab;